<template>
  <v-col cols="12" class="py-0 pl-0">
    <v-row class="pb-6">
      <span class="txtHeader">Resumo</span>
    </v-row>
    <v-expansion-panels accordion v-model="step" class="border-16">
      <v-expansion-panel v-for="menuItem in menuItens" :key="menuItem.id" :disabled="!(menuItem.id < step)">
        <v-expansion-panel-header color="#F4F4F5">
          <v-row align="center" class="pl-0 pr-0">
            <v-avatar v-if="menuItem.id >= step" color="primary" size="24" >
              <span class="number">{{ menuItem.id + 1 }}</span>
            </v-avatar>
            <v-badge v-else icon="mdi mdi-check" color="success" inline ></v-badge>
            <span class="panelHeader pl-2">{{ menuItem.title }}</span>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-list>
            <v-list-item v-for="item in menuItem.itens" :key="item.id" class="pl-0 pr-0">
              <v-row align="center" class="pl-0 pr-0">
                <span class="mdi mdi-circle itemMenuDefault"></span>
                <v-col cols="10" class="pb-0">
                  <v-row>
                    <span class="panelItem">{{ item.title }}</span>
                  </v-row>
                  <v-row>
                    <span class="panelSubItem">{{ item.subtitle }}</span>
                  </v-row>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-col>
</template>
<script>
export default {
  props: {
    value: null,
    menuItens: null
  },
  data () {
    return {
    }
  },
  computed: {
    step: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>
<style scoped>
.txtHeader {
  font-weight: 600;
  font-size: 20px;
}
.border-16 {
  border-radius: 16px !important;
}
.panelHeader {
  font-size: 16px;
  font-weight: 700 !important;
}
.panelItem {
  font-size: 16px;
  font-weight: 500;
}
.panelSubItem {
  font-size: 12px;
  font-weight: 400;
}
.itemMenuSuccess {
  font-size: 20px !important;
  color: green;
}
.itemMenuDefault {
  font-size: 12px !important;
  color: var(--v-primary-base);
}
.number {
  color: white;
}
@media (max-width: 1400px) {
  .panelHeader {
    font-size: 14px;
  }
  .panelItem {
    font-size: 14px;
  }
}
</style>
